<template>
  <div :class="rootClasses">
    <Button v-if="showDef" @click="handleDefClick" class="default-btn" shape="round">
      <slot name="defContent">
        {{ defContent }}
      </slot>
    </Button>
    <Button @click="handlePrimeClick" :disabled="disabled" :loading="loading" class="primary-btn" type="primary" shape="round">
      <slot name="primaryContent">
        {{ primaryContent }}
      </slot>
    </Button>
    <Button v-if="showSubPrime" @click="handleSubPrimeClick" class="primary-btn" type="primary" shape="round">
      <slot name="primaryContent">
        {{ subPrimaryContent }}
      </slot>
    </Button>
  </div>
</template>
<script>
// 询问性的按钮组: 接受,拒绝
import { Button } from 'ant-design-vue'
export default {
  name: 'BasicBtnGroup',
  components: {
    Button
  },
  props: {
    layout: {
      type: String, // 两个按钮的位置关系 'horizontal', 'vertical'
      default: 'horizontal'
    },
    primaryContent: {
      type: String,
      default() {
        return this.$t('common.Ok')
      }
    },
    defContent: {
      type: String,
      default() {
        return this.$t('common.Cancel')
      }
    },
    subPrimaryContent: {
      type: String,
      default() {
        return this.$t('common.Ok')
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    showDef: {
      type: Boolean,
      default: true
    },
    showSubPrime: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    rootClasses() {
      return `basic-btn-group layout-${this.layout}`
    }
  },
  methods: {
    handlePrimeClick() {
      this.$emit('primeClick')
    },
    handleDefClick() {
      this.$emit('defClick')
    },
    handleSubPrimeClick () {
      this.$emit('subPrimeClick')
    }
  }
}
</script>
<style lang="less" scoped>
@import url(~@/styles/font.less);
@import url(~@/styles/button.less);
.basic-btn-group {
  &.layout-horizontal {
    display: flex;
    justify-content: space-between;
  }

  &.layout-vertical {
    display: flex;
    flex-direction: column-reverse;
    ::v-deep .ant-btn {
      display: block;
      width: 100%;
      & + .ant-btn {
        margin-bottom: 20px;
      }
    }
  }

  ::v-deep .ant-btn {
    .medium-font(16);
    height: 40px;
    line-height: 20px;
    border-radius: 20px;
    padding: 10px 40px;
    border-color: transparent;
  }

  .default-btn {
    .default-btn-mixins();
  }

  .primary-btn {
    .primary-btn-mixins()
  }
}
</style>
